import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.27.4_@playwright+test@1.57.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lang]/layout.tsx\",\"import\":\"Kanit\",\"arguments\":[{\"subsets\":[\"thai\",\"latin\"],\"weight\":[\"400\",\"700\"],\"variable\":\"--font1\"}],\"variableName\":\"kanit\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/.pnpm/react-hot-toast@2.5.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/BusinessVerification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/ContentLanguageVerification.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["MouseMovementProvider"] */ "/app/src/app/[lang]/MouseMovementContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DisableRightClick"] */ "/app/src/app/[lang]/RightClickContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/StoreProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/gtm/GtmPageView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SurveyStorageCleaner"] */ "/app/src/components/survey-storage-cleaner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareSocialModal"] */ "/app/src/components/ui/share-social-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VersionGuard"] */ "/app/src/components/version-guard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleLayoutProvider"] */ "/app/src/lib/providers/article-layout-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/app/src/lib/providers/cart-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ColorStyleProvider"] */ "/app/src/lib/providers/color-style-privider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutStyleProvider"] */ "/app/src/lib/providers/layout-style-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductCompareProvider"] */ "/app/src/lib/providers/product-compare-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductLayoutProvider"] */ "/app/src/lib/providers/product-layout-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileProvider"] */ "/app/src/lib/providers/profile-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShopCurrencyProvider"] */ "/app/src/lib/providers/shop-currency-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SystemConfigProvider"] */ "/app/src/lib/providers/system-config-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackingProvider"] */ "/app/src/lib/providers/tracking-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/util/ScriptRunnerGlobal.tsx");
